import { render, staticRenderFns } from "./showdate.vue?vue&type=template&id=271ffd70&scoped=true&"
import script from "./showdate.vue?vue&type=script&lang=js&"
export * from "./showdate.vue?vue&type=script&lang=js&"
import style0 from "./showdate.vue?vue&type=style&index=0&id=271ffd70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ffd70",
  null
  
)

export default component.exports